const state = {
  loader: false,
  rol: null,
  userInfo: null,
}

const getters = {
  getLoader (state) {
    return state.loader
  },
  getRol(state){
    return state.rol
  },
  getUserInfo(state){
    return state.userInfo
  }
}

const mutations = {
  setLoader (state, payload) {
    state.loader = payload
  },
  setRol(state, payload){
    state.rol = payload
  },
  setUserInfo(state, payload){
    state.userInfo = payload
  }
}

const actions = {
  updateLoader ({commit}, payload) {
    commit('setLoader', payload)
  },
  updateRol({commit}, payload){
    commit('setRol', payload)
  },
  updateUserInfo({commit}, payload){
    commit('setUserInfo', payload)
  }
}

export default {
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
}



// WEBPACK FOOTER //
// ./src/vue/store/modules/session.js